let html = `
<svg><use xlink:href="#sprite-broadcast"></use></svg>
`

export default html